var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "05028F93-EF13-433C-B9BA-41D2053F086E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "08-Team-Mesh-Hover",
    transform: "translate(-1185.000000, -126.000000)",
    stroke: "#fcab4e",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(1166.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insights",
    transform: "translate(19.000000, 66.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    points: "0.6251 0.6249 0.6251 17.3749 17.3751 17.3749 17.3751 0.6249"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.2491,
    y1: 17.3451,
    x2: 6.2491,
    y2: 11.0801,
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.751,
    y1: 17.1474,
    x2: 11.751,
    y2: 12.5424,
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.001,
    y1: 17.1474,
    x2: 9.001,
    y2: 13.7974,
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.501,
    y1: 17.1474,
    x2: 14.501,
    y2: 11.0804,
    id: "Stroke-9"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-12",
    points: "14.501 7.64 14.501 4.458 11.318 4.458"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.752,
    y1: 9.6161,
    x2: 14.501,
    y2: 4.4601,
    id: "Stroke-13"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.4991,
    y1: 8.6664,
    x2: 5.8571,
    y2: 6.1064,
    id: "Stroke-14"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.752,
    y1: 9.623,
    x2: 5.857,
    y2: 6.106,
    id: "Stroke-15"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.4991,
    y1: 17.1474,
    x2: 3.4991,
    y2: 12.5424,
    id: "Stroke-16"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.826d8123b692057bb334cfd87d30af44.svg";
export { ForwardRef as ReactComponent };